import type { ErrorDetails } from 'global/helpers/requestError'

export interface StatusUpdateFormValues {
  wayPointType: 'PUP' | 'CUS' | 'DEL'
  statusId: string
  statusCode: string
  reasonCode?: string
  createdAt?: string
  createdAtDate?: Date | null
  createdAtTime?: Date | null
  shipmentNumber: string
  comment?: string
  signee?: string
  paperless?: boolean
  signature?: string
}

export interface StatusUpdateWithAttachmentsFormValues extends StatusUpdateFormValues {
  popFiles?: string[]
  podFiles?: string[]
  photoFiles?: string[]
  palletFile?: string
}

export interface DocumentsUploadFormValues {
  popFiles?: string[]
  podFiles?: string[]
  photoFiles?: string[]
  palletFile?: string
  troFile?: string
}

export interface BulkStatusUpdateFormValues extends Omit<StatusUpdateFormValues, 'shipmentNumber'> {
  shipmentNumbers: string[]
}

export interface BulkDocumentsUploadFormValues extends DocumentsUploadFormValues {
  shipmentNumbers: string[]
}

export interface BulkDocumentsUploadResponse {
  [key: string]: AttachmentResult[]
}

export enum AttachmentResultType {
  SUCCESS = 'com.etrucknow.authorizationgateway.service.waypoints.WaypointAttachmentService.AttachmentResult.Success',
  FAILURE = 'com.etrucknow.authorizationgateway.service.waypoints.WaypointAttachmentService.AttachmentResult.Failure',
}

export interface AttachmentResultSuccess {
  type: AttachmentResultType.SUCCESS
  fileId: string
}

export interface AttachmentResultFailure {
  type: AttachmentResultType.FAILURE
  fileId: string
  reasons: ErrorDetails[]
}

export type AttachmentResult = AttachmentResultSuccess | AttachmentResultFailure
